import { usePostMutation } from "hooks/useClientPortalQuery";
import { AxiosError } from "axios";
import { ApiErrorResponse, RescheduleAppointmentRequest } from "types/generated/models";
import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";
import { useAppointmentBookingApi } from "hooks/useAppointmentBookingApi";

export function useAppointmentReschedule() {
    const { getEndpoint } = useAppointmentBookingApi();

    const { mutateAsync, isPending, isSuccess, error } = usePostMutation<
        void,
        AxiosError<ApiErrorResponse>,
        RescheduleAppointmentRequest
    >({
        url: getEndpoint("Reschedule"),
    });

    const rescheduleAppointmentAsync = async (request: RescheduleAppointmentRequest) => {
        if (!request?.appointmentId || !request?.newDateTime || request?.offset == null) {
            throw new Error("Invalid reschedule appointment request.");
        }
        await mutateAsync(request);
        enqueueSnackbar("Appointment rescheduled successfully!", { variant: "success" });
    };

    return { rescheduleAppointmentAsync, isSaving: isPending, isSuccess, error };
}
